module.exports = __webpack_public_path__ + "static/img/hujiao2.8c84efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/hujiao2.png
// module id = DEbv
// module chunks = 24